var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMui(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_12_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8438 80.1133V40.144L63.4181 60.1287V73.4517L41.0352 60.1287V86.7748L29.8438 80.1133Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.418 60.1287L96.9923 40.144V80.1133L74.6094 93.4364L63.418 86.7748L85.8008 73.4517V60.1287L63.418 73.4517V60.1287Z",
    fill: "#0081CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.418 86.7749V100.098L85.8008 113.421V100.098L63.418 86.7749Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8008 113.421L119.375 93.4364V66.7902L108.184 73.4517V86.7748L85.8008 100.098V113.421ZM108.184 60.1287V46.8056L119.375 40.144V53.4671L108.184 60.1287Z",
    fill: "#0081CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.5315,
    height: 92.3077,
    fill: "white",
    transform: "translate(29.8438 30.769)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMui);
export default __webpack_public_path__ + "static/media/MUI.66032dbcb7f5b7df72fa32f77d831e15.svg";
export { ForwardRef as ReactComponent };